/**
 * 从API加载往APP引流的各种链接的地址
 */
define('data/appentry', ['jquery', 'log', 'data/api'], ($, log, api) => {
    // 发起Ajax请求获取数据，并缓存在本地
    function fetch() {
        const d = $.Deferred(); // eslint-disable-line

        api.get({
            url: `/api/qrcode/app?fr=${RRC.fr}&platform=PC`,
            cache: true,
        })
            .done((json) => {
                d.resolve(json.status === 0 ? json.data || {} : {});
            })
            .fail((err) => {
                log.push(['_trackEvent', 'appentry-apierror', 'click', '']);
                d.reject(err);
            });

        return d.promise();
    }

    // fallback to default url
    function fallback(key, type = 'url') {
        log.push(['_trackEvent', 'appentry-fallback', 'click', '']);
        if (type === 'qr') {
            return `//mktqr.rrcimg.com/qr/image-qr-pc_yl-${RRC.fr}.png`;
        }

        return `//app.renrenche.com/?error=fallback&fr=${RRC.fr}&rukou=${key}`;
    }

    // 给所有的 rrc-app-entry 节点拿到数据
    function init(container) {
        if (RRC.dynamicAppEntry === false) {
            return;
        }

        const ndContainer = $(container || 'body');
        const ndList = ndContainer.find('[rrc-app-entry]');
        if (ndList.size() === 0) {
            return;
        }

        fetch().then((data) => {
            ndList.each((i, item) => {
                const ndItem = $(item);
                const entry = ndItem.attr('rrc-app-entry');
                if (entry && item.tagName && item.tagName.toUpperCase() === 'IMG') {
                    if (data[entry] && data[entry].qr) {
                        ndItem.attr('src', data[entry].qr.replace(/^http:/, ''));
                    } else {
                        ndItem.attr('src', fallback(entry, 'qr'));
                    }
                }
                if (entry && item.tagName && item.tagName.toUpperCase() === 'A') {
                    if (data[entry] && data[entry].url) {
                        ndItem.attr('href', data[entry].url);
                    } else {
                        ndItem.attr('href', fallback(entry, 'url'));
                    }
                }
            });
        });
    }

    // 获取某个引流入口对应的URL
    function get(key) {
        const d = $.Deferred(); // eslint-disable-line

        if (!key) {
            d.reject(new Error('key for app entry is required'));
        }

        fetch().then((data) => {
            if (data[key] && data[key].url) {
                d.resolve(data[key].url);
            } else {
                d.resolve(fallback(key));
            }
        });

        return d.promise();
    }

    return {
        init,
        get,
        fallback,
        fetch,
    };
});
